import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import styles from "./CareerJobs.module.scss";

const CareerJobs = ({ language }) => {
  const { t } = useTranslation("common");
  const [isLoading, setIsLoading] = useState(true);
  const [iframeHeight, setIframeHeight] = useState("1200px"); // Standard baseline for high-res screens

  useEffect(() => {
    const handleMessage = (event) => {
      // Security: Handle whitecarrot.io subdomains or custom domains
      if (!event.origin.includes("whitecarrot.io")) return;

      let data = event.data;

      // Handle string messages (often used by iframe-resizer or legacy systems)
      if (typeof data === "string") {
        // Support for iframe-resizer format: "[iFrameSizer]iframeId:height:1234:..."
        if (data.includes("[iFrameSizer]")) {
          const parts = data.split(":");
          if (parts.length > 3 && parts[1] === "height") {
            setIframeHeight(`${parts[2]}px`);
            return;
          }
        }

        try {
          data = JSON.parse(data);
        } catch (e) {
          // Not JSON, continue to check if it's a numeric string
          if (!isNaN(data)) {
            setIframeHeight(`${data}px`);
            return;
          }
        }
      }

      // Check for various common height message structures
      if (data && typeof data === "object") {
        if (data.type === "height" && data.value) {
          setIframeHeight(`${data.value}px`);
        } else if (data.height) {
          setIframeHeight(`${data.height}px`);
        } else if (data.scrollHeight) {
          setIframeHeight(`${data.scrollHeight}px`);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className={`${styles.componentWrapper} ${language || ""}`}>
      <Helmet>
        <title>{t("careersMetaTitle")}</title>
        <meta
          name="description"
          content={t("careersMetaDescription")}
        />
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_BASE_URL}/jobs`}
        />
      </Helmet>
      <div className={styles.iframeContainer}>
        {isLoading && (
          <div className={styles.loaderContainer}>
            <div className={styles.loader} />
            <p>Loading Careers Portal...</p>
          </div>
        )}
        <iframe
          src={process.env.REACT_APP_WHITECARROT_CAREERS_URL}
          title="Frank Porter Careers"
          frameBorder="0"
          allowFullScreen
          onLoad={handleIframeLoad}
          className={!isLoading ? styles.loaded : ""}
          style={{ height: iframeHeight }}
        />
      </div>
    </div>
  );
};

export default CareerJobs;